/** EvolveRPG — Encyclopedia English overrides. Fast-play, momentum-driven voice. Only keys with world flavor are overridden; the rest inherit the shared shell. */
export const encyclopediaEvoEn = {
  // EncyclopediaPage
  'encyclopedia.page.seoDescription':
    'Search the EvolveRPG codex — rules, character options, gear, settings and more.',
  'encyclopedia.page.subtitle': 'The living codex of every rule, build, and setting in EvolveRPG.',
  'encyclopedia.page.systemNotLivePrefix': 'The codex hasn’t opened yet for',
  'encyclopedia.page.systemNotLiveSuffix':
    '. No content is live for this system yet — check back soon.',
  'encyclopedia.page.settingNotLiveSuffix':
    ' are still being built — its entries aren’t live yet. Check back as more settings launch.',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': 'Unlock {name} (EvolveRPG content)',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Search the Codex',
  'encyclopedia.globalSearch.placeholder': 'Search rules, builds, gear, settings…',
  'encyclopedia.globalSearch.loading': 'Searching…',
  'encyclopedia.globalSearch.empty': 'Nothing found for “{q}”.',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'EvolveRPG content: unlock to read',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.body':
    "EvolveRPG's rules and stats are bound to the Core book. The open SRD canon stays free.",
  'encyclopedia.lockedGate.unlockCta': 'Unlock EvolveRPG',
  'encyclopedia.lockedGate.backerNote':
    'Backers who pledged for EvolveRPG already own this. Sign in to unlock it on your account.',

  // EntityDetailPage
  'encyclopedia.detail.addError': 'Could not reach the campaign vault. Try again later.',
  'encyclopedia.detail.seoDescription': '{name}, a {label} in the EvolveRPG Encyclopedia.',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.emptyBody': 'Be the first to discuss this entry.',

  // tabs/ClaimsTab
  'encyclopedia.claims.emptyBody': 'No player has claimed this entry yet.',
}
